import React, { useState, useEffect } from "react";

import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Spin } from "antd";

const PAGE_SIZE = 4;
const AWS_URL = "https://s3-eu-west-1.amazonaws.com/surveyefficiencecell/";

const Bestof = ({ closeModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  var settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
    // vertical: true,
    // verticalSwiping: true
  };
  const fetchPictures = async () => {
    setIsLoading(true);
    const result = await axios.post("https://backend.efficiencesell.fr/api/medias", {
      match: {
        best: true,
        user_email: ["emile.mendouaze@upsell.fr"],
        client_id: 1,
        "media.response": { $exists: true }
      },
      sort: { visit_start_date: -1 },
      page,
      pageSize: PAGE_SIZE
    });

    const _docs = [...data, ...result.data.docs];
    setData(_docs);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPictures();
  }, [page]);
  return (
    <div
      style={{
        position: "absolute",
        height: "100vh",
        width: "100vw",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        background: "white"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
        <div style={{ fontSize: 40 }}>Best Of </div>
        <img src="/img/logo_upsell_2020.png" height={50} onClick={closeModal} />
      </div>
      <div
        style={{
          height: "calc(100vh - 50px)"
        }}
      >
        <Slider
          {...settings}
          afterChange={index => {
            if (index + 2 >= PAGE_SIZE * page) {
              setPage(page + 1);
            }
          }}
        >
          {data.map((item, index) => (
            <div style={{ background: "green" }} key={item._id}>
              {isLoading ? (
                <Spin></Spin>
              ) : (
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  <img
                    style={{ objectFit: "cover", width: "80%", height: "80%" }}
                    src={AWS_URL + item.media.response.url}
                  />
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: 10
                    }}
                  >
                    <div style={{ fontSize: 18, width: "100%", textAlign: "center" }}>{`${index + 1}- ${
                      item.salepoint.pdc_label
                    }`}</div>
                    <div>({item.location.label})</div>
                    <div>secteur : {item.sector.sector_label}</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Bestof;



// WEBPACK FOOTER //
// src/pages/admin/poc/BestOf/BestOf.js